// ZAM values share a saved step with RAM/wing dimensions in the PG-400 templates.
export function expandDimensionItems(items = []) {
  return items.flatMap(item => {
    const dimensions = [item?.zamWidthValue, item?.zamHeightValue]
      .map(value => String(value ?? '').replace(/mm/ig, '').replace(/,/g, '.').trim());

    if (dimensions.some(value => value === '')) {
      return [item];
    }

    return [
      {
        id: `${item.id}-zam`,
        name: 'ZAM Maß',
        value: dimensions.map(value => `${value}mm`).join(' x '),
      },
      item,
    ];
  });
}
